import styled from 'styled-components'
import theme from 'styles/theme'
import { space } from 'styled-system'

const Wrapper = styled.label`
  display: block;
  ${space}

  > * {
    ${(props) =>
      props.isDisabled &&
      `
      color: ${theme.colors.sagelight}};
    `}

    ${(props) =>
      props.hasError &&
      `
      color: ${theme.colors.red}};
    `}
  }
`

export { Wrapper as default }
